import { connect } from 'react-redux'

import { selectAction, visiblePlacesAction, collapseSidebarAction, editModeChangeAction, loadingAction,
  waitForServerAction, deleteFeatureAction, changeShowFiltersAction, openPanelAction, hidePopupAction, 
  saveFeatureGeomAction, addModeChangeAction } from './actions'
import MapComponent from './MapComponent'

const mapStateToProps = (state) => {
  return {
    selected: state.selected,
    editMode: state.editMode,
    loading: state.loading,
    isWaitingForResponse: state.isWaitingForResponse,
    deletedFeature: state.deletedFeature,
    collapsed: state.collapsed,
    isPanelOpened: state.isPanelOpened,
    hidePopup: state.hidePopup,
    saveFeatureGeomId: state.saveFeatureGeomId,
    savePlaceOrCluster: state.savePlaceOrCluster,
    addingFeature: state.addingFeature,
    shouldBeShownIds: state.shouldBeShownIds,
    accessibilityVersion: state.accessibilityVersion
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSelectClick: selected => dispatch(selectAction(selected)),
    onVisiblePlacesChange: (places) => dispatch(visiblePlacesAction(places)),
    onCollapseSidebar: collapsed => dispatch(collapseSidebarAction(collapsed)),
    onEditModeChange: editMode => dispatch(editModeChangeAction(editMode)),
    onLoading: loading => dispatch(loadingAction(loading)),
    waitingForResponse: status => dispatch(waitForServerAction(status)),
    featureWasDeleted: _ => dispatch(deleteFeatureAction(null)),
    changeShowFilters: show => dispatch(changeShowFiltersAction(show)),
    openPanel: open => dispatch(openPanelAction(open)),
    doHidePopup: hide => dispatch(hidePopupAction(hide)),
    doneSavingFeatureGeom: _ => dispatch(saveFeatureGeomAction(null, 'done')),
    doneSavingFeatureGeomReturning: feature => dispatch(saveFeatureGeomAction(null, ['done', feature])),
    onAddModeChange: mode => dispatch(addModeChangeAction(mode)),
  }
}

const MapContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(MapComponent)

export default MapContainer



// WEBPACK FOOTER //
// ./src/MapContainer.js